import {
  FETCH_SPORT_TYPES,
  UPDATE_SPORT_TYPE,
  CREATE_SPORT_TYPE,
  DELETE_SPORT_TYPE
} from "../../store/constants/hwk";

export function fetchSportTypes() {
  return {
    type: FETCH_SPORT_TYPES
  };
}

export function updateSportType(payload = {}) {
  return {
    type: UPDATE_SPORT_TYPE,
    payload
  };
}

export function createSportType(payload = {}) {
  return {
    type: CREATE_SPORT_TYPE,
    payload
  };
}

export function deleteSportType(payload = {}) {
  return {
    type: DELETE_SPORT_TYPE,
    payload
  };
}
